import axios, { AxiosInstance } from 'axios';

let axiosInstance: AxiosInstance;

const http = function(): AxiosInstance {

    if(axiosInstance === undefined)
    {
        createInstance();
    }
    return axiosInstance;
}

const createInstance = function(): void{
    
    const baseApi = process.env.VUE_APP_API_BASE ? process.env.VUE_APP_API_BASE : '';
    axiosInstance = axios.create({
        baseURL: baseApi
    });
}


export default http;
